export default function (instance) {
  return {
    logUser(payload) {
      return instance.post("/admin/token", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
    getMe() {
      return instance.get("/admin/me");
    },
  };
}
